<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 mt-4"></div>
      <div class="col my-3">
        <h6>Detect faces from your webcam. When ready click "enable webcam" below and accept
          access to the webcam.</h6>
        <div id="liveView" ref="liveView" class="videoView">
          <video ref="video" id="webcam" class="webcam" autoplay playsinline></video>
        </div>
      </div>
      <div class="col my-4">
        <h6 class="mb-2">Detection</h6>
        <div class="imageView">
          <img ref="outputImgOriginal" id="outputImgOriginal" class="">
        </div>
      </div>
      <div class="col-lg-12 mb-3">
        <h6 class="mb-2">Image to send</h6>
        <img ref="outputImg" class="img-preview">
      </div>
    </div>
    <button class="btn btn-primary mr-2" @click="enableCam">Enable web cam</button>
    <button class="btn btn-primary mr-2" @click="run" v-if="enableCapture">Take photo</button>

    <div v-if="detections.length>0">
      <hr>
      <ul v-for="(detection, index) in detections" :key="index">
        <li>
          Face {{ index + 1 }}<br>
          Confidence: {{ Math.round(parseFloat(detection.categories[0].score) * 100) }} %<br>
          Bounding Box: {{ detection.boundingBox }}
        </li>
      </ul>

    </div>
  </div>
</template>


<script>

import {FaceDetector, FilesetResolver, Detection} from "@mediapipe/tasks-vision";

export default {
  name: 'TermsPage',
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: 'Mediapipe'
  },

  components: {},

  data() {
    return {
      faceDetector: FaceDetector,
      runningMode: 'IMAGE',
      video: {},
      liveView: {},
      lastVideoTime: -1,
      children: [],
      detections: [],
      canvasDetection: null,
      enableCapture: false,
      stream: null,
    }
  },

  created() {


  },

  async mounted() {
    this.video = this.$refs.video
    this.liveView = this.$refs.liveView
    this.canvasDetection = this.$refs.canvasDetection

    await this.initializeFaceDetector()
    if (!this.hasGetUserMedia) {
      console.warn("getUserMedia() is not supported by your browser");
    }

  },
  watch: {},
  computed: {
    hasGetUserMedia() {
      return !!navigator.mediaDevices.getUserMedia;
    },
    mainDectection() {
      return this.detections[0]
    }
  },
  beforeDestroy() {
    // this.pauseVideo()

    this.stopMediaStreamTrack()

  },
  methods: {
    async initializeFaceDetector() {
      const vision = await FilesetResolver.forVisionTasks(
          "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm"
      );
      this.faceDetector = await FaceDetector.createFromOptions(vision, {
        baseOptions: {
          modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite`,
          delegate: "GPU",

        },
        minDetectionConfidence: 0.7,
        runningMode: this.runningMode
      });
    },

    async enableCam(event) {
      if (!this.faceDetector) {
        alert("Face Detector is still loading. Please try again..");
        return;
      }

      // getUsermedia parameters
      const constraints = {
         video: {

          width: {min: 320, ideal: window.innerHeight > window.innerWidth ? 1920 : 1000},
          height: {min: 240, ideal: window.innerHeight > window.innerWidth ? 1500 : 740},
          // aspectRatio: {ideal: 4/3},
          frameRate: {
            min: 15,
            ideal: 30,
          },
          facingMode: this.defaultCamera
        }
      };

      // Activate the webcam stream.
      let self = this
      navigator.mediaDevices
          .getUserMedia(constraints)
          .then((stream) => {
            this.stream = stream
            self.video.srcObject = stream;
            this.enableCapture = true
            /*self.video.addEventListener("loadeddata", function () {
              //self.predictWebcam()
              self.enableCapture = true
            }, false);*/
          })
          .catch((err) => {
            console.error(err);
          });
    },
    clear() {
      const highlighters = this.$refs.outputImgOriginal.parentNode.getElementsByClassName(
          "highlighter"
      );
      while (highlighters[0]) {
        highlighters[0].parentNode.removeChild(highlighters[0]);
      }

      const infos = this.$refs.outputImgOriginal.parentNode.getElementsByClassName("info");
      while (infos[0]) {
        infos[0].parentNode.removeChild(infos[0]);
      }
      const keyPoints = this.$refs.outputImgOriginal.parentNode.getElementsByClassName("key-point");
      while (keyPoints[0]) {
        keyPoints[0].parentNode.removeChild(keyPoints[0]);
      }

    },
    async run() {
      await this.take()
      await this.capture()
    },
    take() {
      return new Promise((resolve, reject) => {
        this.clear()

        //this.video.pause()
        let canvas = document.createElement('CANVAS')
        canvas.width = this.video.videoWidth;
        canvas.height = this.video.videoHeight;

        canvas.getContext('2d').drawImage(this.video, 0, 0, this.video.videoWidth, this.video.videoHeight);
        // Image that will be used for detection
        this.$refs.outputImgOriginal.src = canvas.toDataURL('image/jpeg')
        this.$refs.outputImgOriginal.onload = () => {
          resolve()
        }

      })

      // Set image on a canvas
      /*canvas.toBlob = (blob) => {
        const img = new Image();
        img.src = window.URL.createObjectUrl(blob);
      }*/
    },
    async capture() {

      if (!this.faceDetector) {
        console.log("Wait for objectDetector to load before clicking");
        return;
      }

      // faceDetector.detect returns a promise which, when resolved, is an array of Detection faces
      try {
        this.detections = this.faceDetector.detect(this.$refs.outputImgOriginal).detections;

        // sort detections by area descending
        this.detections = this.detections.sort((a, b) => {
          return (b.boundingBox.width * b.boundingBox.height) - (a.boundingBox.width * a.boundingBox.height)
        });

        this.displayImageDetections(this.detections, this.$refs.outputImgOriginal);
      } catch (error) {
        // ERROR DETECTION
        alert('DETECTION FAILED !')
        console.log(error)
      }

    },

    displayImageDetections(detections, resultElement) {
      this.clear()
      const ratio = resultElement.height / resultElement.naturalHeight;


      for (let detection of detections) {
        // Description text
        const p = document.createElement("p");
        p.setAttribute("class", "info");
        p.innerText =
            "Confidence: " +
            Math.round(parseFloat(detection.categories[0].score) * 100) +
            "% .";
        // Positioned at the top left of the bounding box.
        // Height is whatever the text takes up.
        // Width subtracts text padding in CSS so fits perfectly.
        p.style =
            "left: " +
            detection.boundingBox.originX * ratio +
            "px;" +
            "top: " +
            (detection.boundingBox.originY * ratio - 30) +
            "px; " +
            "width: " +
            (detection.boundingBox.width * ratio - 10) +
            "px;" +
            "hight: " +
            20 +
            "px;";
        const highlighter = document.createElement("div");
        highlighter.setAttribute("class", "highlighter");
        highlighter.style =
            "left: " +
            detection.boundingBox.originX * ratio +
            "px;" +
            "top: " +
            detection.boundingBox.originY * ratio +
            "px;" +
            "width: " +
            detection.boundingBox.width * ratio +
            "px;" +
            "height: " +
            detection.boundingBox.height * ratio +
            "px;";

        resultElement.parentNode.appendChild(highlighter);
        resultElement.parentNode.appendChild(p);
        for (let keypoint of detection.keypoints) {
          const keypointEl = document.createElement("spam");
          keypointEl.className = "key-point";
          keypointEl.style.top = `${keypoint.y * resultElement.height - 3}px`;
          keypointEl.style.left = `${keypoint.x * resultElement.width - 3}px`;
          resultElement.parentNode.appendChild(keypointEl);
        }
      }
      this.createImageToSend()

    },
    createImageToSend() {
      let canvas = document.createElement('CANVAS')

      // 43 % of width
      const wPerc = 40
      const hPerc = 60
      const wPadding = this.mainDectection.boundingBox.width * wPerc / 100
      const hPadding = this.mainDectection.boundingBox.width * hPerc / 100
      canvas.width = this.mainDectection.boundingBox.width + wPadding;
      canvas.height = this.mainDectection.boundingBox.height + hPadding;
      canvas.getContext('2d').drawImage(this.$refs.outputImgOriginal,
          this.mainDectection.boundingBox.originX - (wPadding / 2),
          this.mainDectection.boundingBox.originY - (hPadding - (wPadding / 4)),
          this.mainDectection.boundingBox.width + wPadding,
          this.mainDectection.boundingBox.height + hPadding,
          0,
          0,
          this.mainDectection.boundingBox.width + wPadding,
          this.mainDectection.boundingBox.height + hPadding,
      );
      this.$refs.outputImg.src = canvas.toDataURL('image/jpeg')
      canvas.toBlob(blob => {
        this.$emit('photoTaken', {faceImg: blob, faceEncoding: []})
      }, 'image/jpeg');

    },
    stopMediaStreamTrack() {
      this.video.srcObject = null;
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop())
      }
    },
  },

}
</script>
<style>
.img-preview {
  transform: rotateY(180deg);
}

.webcam {
  clear: both;
  display: block;
  transform: rotateY(180deg);

}

.imageView {
  position: relative;
  transform: scaleX(-1);
}

.videoView {

  float: left;
  width: 48%;
  margin: 2% 1%;
  cursor: pointer;
}

.videoView p, .imageView p {
  white-space: nowrap;
  position: absolute;
  padding-bottom: 5px;
  padding-top: 5px;
  background-color: #007f8b;
  color: #fff;
  border: 1px dashed rgba(255, 255, 255, 0.7);
  z-index: 2;
  font-size: 12px;
  margin: 0;
}

.highlighter {
  background: rgba(0, 255, 0, 0.25);
  border: 1px dashed #fff;
  z-index: 1;
  position: absolute;
}


.key-point {
  position: absolute;
  z-index: 1;
  width: 3px;
  height: 3px;
  background-color: #ff0000;
  /* border: 1px solid #ffffff; */
  border-radius: 50%;
  display: block;
}
</style>
